// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".closed-image[data-v-2848045e]{width:350px}h1[data-v-2848045e]{color:var(--themeColor);font-size:24px}.sorry p[data-v-2848045e]{font-size:18px}.copyright[data-v-2848045e]{text-transform:uppercase}", ""]);
// Exports
module.exports = exports;
